import axios from 'axios';

const api = axios.create({
  //timeout: 10000, // 10 seconds timeout
  headers: {
    'Content-Type': 'application/json; charset=UTF-8',
  }
});






export default api;



// WEBPACK FOOTER //
// ./src/api/httpClient.js